"use client";
import React, { useEffect, useState } from "react";
import { MenuIcon } from "@/assets/icons";
import MenuPage from "./menuPage";
import ThemeSwitcher from "../ThemeSwitcher.js/index.jsx";

export default function Menu() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    return () => {
      document.querySelector("html").style.overflow = "unset";
    };
  }, []);

  const menuHandler = () => {
    if (!show) {
      document.querySelector("html").style.overflow = "hidden";
    } else {
      document.querySelector("html").style.overflow = "unset";
    }
    setTimeout(() => {
      window.scrollTo({ top: 0 });
    }, 200);
    setTimeout(() => {
      setShow((show) => !show);
    }, 70);
  };

  return (
    <>
      <div
        onClick={menuHandler}
        className={`menu-btn max-lg:flex lg:hidden  dark:text-dark-icon-default cursor-pointer text-icon-default ${
          show ? "active" : ""
        }`}
      >
        <MenuIcon />
      </div>
      {show ? <MenuPage /> : ""}
    </>
  );
}
